import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { CalculationHistory } from '@/components/CalculationHistory';
import { useCalculationHistory } from '@/hooks/useCalculationHistory';

export const PercentageChange: React.FC = () => {
  const [originalValue, setOriginalValue] = useState<string>('');
  const [newValue, setNewValue] = useState<string>('');
  const [result, setResult] = useState<{ percentage: number; type: string } | null>(null);
  const { history, favorites, addCalculation, toggleFavorite, clearHistory } = useCalculationHistory();

  const calculate = () => {
    const original = parseFloat(originalValue);
    const newVal = parseFloat(newValue);
    
    if (!isNaN(original) && !isNaN(newVal) && original !== 0) {
      const change = ((newVal - original) / original) * 100;
      const type = change >= 0 ? 'Increase' : 'Decrease';
      const calculatedResult = { percentage: Math.abs(change), type };
      setResult(calculatedResult);
      
      // Add to history
      addCalculation(
        'change',
        { originalValue: original, newValue: newVal },
        `${calculatedResult.percentage.toFixed(2)}% ${calculatedResult.type}`
      );
    }
  };

  return (
    <Card className="shadow-card">
      <CardHeader>
        <CardTitle className="text-lg font-semibold text-card-foreground">
          Percentage Increase/Decrease
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label htmlFor="originalValue" className="text-sm font-medium">
              Original Value
            </Label>
            <Input
              id="originalValue"
              type="number"
              placeholder="Enter original value"
              value={originalValue}
              onChange={(e) => setOriginalValue(e.target.value)}
              className="h-12"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="newValue" className="text-sm font-medium">
              New Value
            </Label>
            <Input
              id="newValue"
              type="number"
              placeholder="Enter new value"
              value={newValue}
              onChange={(e) => setNewValue(e.target.value)}
              className="h-12"
            />
          </div>
        </div>
        
        <Button 
          onClick={calculate}
          className="w-full h-12 bg-calculator-gradient hover:opacity-90 transition-opacity"
        >
          Calculate
        </Button>
        
        {result !== null && (
          <div className="p-4 bg-primary/5 border border-primary/20 rounded-lg shadow-result">
            <p className="text-sm text-muted-foreground mb-1">Result:</p>
            <p className="text-2xl font-bold text-primary">
              {result.percentage.toFixed(2)}% {result.type}
            </p>
          </div>
        )}
        
        <CalculationHistory
          history={history.filter(item => item.type === 'change')}
          favorites={favorites}
          onToggleFavorite={toggleFavorite}
          onClearHistory={clearHistory}
        />
      </CardContent>
    </Card>
  );
};